import React, { useState, useEffect } from "react";

import { Box, Tooltip, TextField, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {
  grnListing,
  getGRNById,
  approveGRN,
} from "../../../services/purchase/services/grnlistServices";

import { Checkbox } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Button,
} from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  getGRNForInvert,
  saveOrUpdateItemInfo,
} from "../../../services/purchase/services/grnlistServices";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
} from "@mui/material";
import CommonDynamicTablePagination from "../../../../common/components/CommonTable/CommonDynamicTablePagination";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";

export default function GRNList() {
  const [selectedRow, setSelectedRow] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openChild, setOpenChild] = useState(false);
  const [approvedRows, setApprovedRows] = useState({});
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [approveRowId, setApproveRowId] = useState(null);
  const [openInvertDialog, setOpenInvertDialog] = useState(false);
  const [invertGRNDetails, setInvertGRNDetails] = useState(null);
  const [loadingInvert, setLoadingInvert] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const [itemsData, setItemsData] = useState([]);
  const [grnNo, setGrnNo] = useState("");
  const [invoice, setInvoice] = useState("");
  const [store, setStore] = useState("");
  const [supplier, setSupplier] = useState("");

  useEffect(() => {
    if (invertGRNDetails?.Descriptions) {
      setItemsData(
        invertGRNDetails.Descriptions.map((desc) => ({
          ...desc,
          Qty: "",
          BatchNo: "",
          ModelNo: "",
          SerialNo: "",
          warrantyStartDate: "",
          warrantyEndDate: "",
          amcstartDate: "",
          amcendDate: "",
          insuranceStartDate: "",
          insuranceEndDate: "",
          locationId: desc.locationId || 0,
        }))
      );
    }
  }, [invertGRNDetails]);

  const handleInputChange = (index, field, value) => {
    const newData = [...itemsData];
    newData[index][field] = value;
    setItemsData(newData);
  };

  const toISOStringWithTime = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return d.toISOString();
  };

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    setSubmitted(true);
    const selectedItems = itemsData.filter((item) => isSelected(item.SrNo));
    const invalidRows = selectedItems.filter(
      (item) =>
        !item.BatchNo?.trim() || !item.ModelNo?.trim() || !item.SerialNo?.trim()
    );

    if (invalidRows.length > 0) {
      alert(
        "Please fill Batch No, Model No, and Serial No for all selected rows."
      );
      return;
    }

    const payload = {
      grnId: invertGRNDetails.GRNId || 0,
      items: selectedItems.map((desc) => ({
        id: desc.id || 0,
        itemId: desc.ItemId || 0,
        batchNo: desc.BatchNo,
        modelNo: desc.ModelNo,
        serialNo: desc.SerialNo,
        quantity: desc.Qty || 1,
        grnId: invertGRNDetails.GRNId || 0,
        warrantyStartDate: toISOStringWithTime(desc.warrantyStartDate),
        warrantyEndDate: toISOStringWithTime(desc.warrantyEndDate),
        amcstartDate: toISOStringWithTime(desc.amcstartDate),
        amcendDate: toISOStringWithTime(desc.amcendDate),
        insuranceStartDate: toISOStringWithTime(desc.insuranceStartDate),
        insuranceEndDate: toISOStringWithTime(desc.insuranceEndDate),
      })),
    };

    saveOrUpdateItemInfo(payload)
      .then((res) => {
        alert("Data submitted successfully!");
        setOpenInvertDialog(false);
      })
      .catch((err) => {
        console.error(err);
        alert("Error submitting data.");
      });
  };

  const smallTextFieldSx = {
    "& .MuiInputBase-input": {
      padding: "4px 8px",
      fontSize: "0.8rem",
    },
  };

  const formatDate = (value) => {
    if (!value) return "";
    return new Date(value).toISOString().slice(0, 10); // "YYYY-MM-DD"
  };

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));
  const [openGRNDialog, setOpenGRNDialog] = useState(false);
  const [getGRNDetails, setGRNDetailData] = useState({
    GRNDetailId: 2,
    OctroiAmt: 0,
    LandedNetRate: 52,
    DiscAmount: 0,
    SchemeDiscAmt: 0,
    TotalReturnQty: 0,
    MRP: 65,
    BatchCode: "1849",
    RectQty: 3,
    Remarks: "",
    BatchExpiryDate: "2012-02-29T18:30:00.000+00:00",
    TaxAmount: 0,
    AcceptQty: 3,
    NetAmount: 155.99,
    POId: 0,
    UnitPurchaseRate: 49.52,
    TotalUsedQty: 0,
    DiscPercent: 0,
    SchemeDiscPer: 0,
    DCId: 0,
    DCQty: 0,
    OctroiPer: 0,
    Specification: "",
    VatAmount: 7.43,
    Conversion: 1,
    OtherTaxAmount: 0,
    ItemId: 43965,
    FreeQty: 0,
    PurchaseRate: 49.52,
    TotalAmount: 148.56,
    GRNId: 2,
    VatPercentage: 5,
    IsConsignment: false,
    POQty: 0,
  });

  const [selected, setSelected] = useState([]);

  const handleSelectRow = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelected(itemsData.map((row) => row.SrNo));
    } else {
      setSelected([]);
    }
  };

  const isSelected = (id) => selected.includes(id);

  const RenderActions = (row) => {
    if (!row) return null;
    const isApproved = !!approvedRows[row.GRNId];

    return (
      <div className="flex">
        <Tooltip title="View">
          <div
            className="text-purple-600 cursor-pointer flex items-center justify-center"
            onClick={() => {
              setOpenGRNDialog(true);

              getGRNById(row.GRNId)
                .then((res) => {
                  setGRNDetailData(res.data.result);
                })
                .catch((err) =>
                  console.error("Error fetching GRN details:", err)
                );
            }}
          >
            <VisibilityOutlinedIcon />
          </div>
        </Tooltip>

        {/* <Tooltip title="Approve">
                    <div>
                        <IconButton
                            disabled={isApproved}
                            onClick={() => {
                                setApproveRowId(row.GRNId);
                                setOpenApproveDialog(true);
                            }}
                            sx={{
                                color: isApproved ? "gray" : "green",
                                padding: "3px",
                            }}
                        >
                            <CheckCircleOutlineIcon />
                        </IconButton>
                    </div>
                </Tooltip> */}

        {/* <Tooltip title={isApproved ? "Inward" : "Disabled"}>
                    <div
                        className={`cursor-pointer ${isApproved ? "text-orange-600" : "text-gray-400"}`}
                        onClick={async () => {
                            if (!isApproved) return;

                            setOpenInvertDialog(true);    // open popup
                            setInvertGRNDetails(null);    // reset previous data
                            setLoadingInvert(true);

                            try {
                                const res = await getGRNForInvert(row.GRNId);
                                console.log("API Data:", res.data);

                                const details = res.data?.result?.[0]; // <-- first object from array
                                setInvertGRNDetails(details);
                            } catch (err) {
                                console.error("Error fetching GRN details:", err);
                            } finally {
                                setLoadingInvert(false);
                            }

                        }}
                    >
                        <SwapHorizIcon style={{ opacity: isApproved ? 1 : 0.5 }} />
                    </div>
                </Tooltip> */}

        <Tooltip title="Inward">
          <div
            className="cursor-pointer text-orange-600"
            onClick={async () => {
              setOpenInvertDialog(true);
              setInvertGRNDetails(null);
              setLoadingInvert(true);

              try {
                const res = await getGRNForInvert(row.GRNId);
                console.log("API Data:", res.data);

                const details = res.data?.result?.[0];
                setInvertGRNDetails(details);
              } catch (err) {
                console.error("Error fetching GRN details:", err);
              } finally {
                setLoadingInvert(false);
              }
            }}
          >
            <SwapHorizIcon />
          </div>
        </Tooltip>

        <Tooltip title="Edit">
          <div className="text-blue-500 mr-1">
            <DriveFileRenameOutlineIcon
              onClick={() => {
                setOpen(true);
                setEdit(true);
              }}
            />
          </div>
        </Tooltip>

        <Tooltip title="Delete">
          <div
            className="text-red-500 mr-3"
            onClick={() => {
              setOpenChild(true);
              setDeleteId(row["GRNId"]);
            }}
          >
            <DeleteOutlineOutlinedIcon />
          </div>
        </Tooltip>
      </div>
    );
  };


  const populateTable = () => {
    if (!fromDate || !toDate) {
      alert("Please select both From Date and To Date");
      return;
    }

    const searchObj = { fromDate, toDate };

    setOpenBackdrop(true);
    grnListing(searchObj)
      .then((response) => {
        console.log("API response:", response.data);
        const res = response.data;
        setDataResult(res.result || res || []);
        setCount(res.count || res.length || 0);
      })
      .catch((error) => {
        console.error("GRN listing error:", error);
      })
      .finally(() => {
        setOpenBackdrop(false);
      });
  };

  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Box component="main" sx={{ flexGrow: 1, p: 3, width: "100%" }}>
          <DrawerHeader />

          <div className="w-full mx-auto ">
            <h1 className="text-xl text-black font-Poppins">GRN Listing</h1>
            <div>
              <div className="flex justify-between w-full items-center mt-2">
                <div className="flex items-center w-full gap-2">
                  <div className="flex items-center gap-2 text-start w-full xl:w-3/4">
                    {/* GRN No Dropdown */}
                    <div style={{ width: "300px" }}>
                      <TextField
                        select
                        label="GRN No"
                        value={grnNo}
                        onChange={(e) => setGrnNo(e.target.value)}
                        size="small"
                        fullWidth
                      >
                        {/* <MenuItem value="">All</MenuItem> */}
                        <MenuItem value="GRN001">P0000006</MenuItem>
                        <MenuItem value="GRN002">P0000005</MenuItem>
                        <MenuItem value="GRN003">P0000004</MenuItem>
                        <MenuItem value="GRN004">P0000002</MenuItem>
                        <MenuItem value="GRN005">P0000001</MenuItem>
                      </TextField>
                    </div>

                    {/* Invoice Dropdown */}
                    <div style={{ width: "300px" }}>
                      <TextField
                        select
                        label="Invoice"
                        value={invoice}
                        onChange={(e) => setInvoice(e.target.value)}
                        size="small"
                        fullWidth
                      >
                        {/* <MenuItem value="">All</MenuItem> */}
                        <MenuItem value="INV001">33819</MenuItem>
                        <MenuItem value="INV002">33568</MenuItem>
                        <MenuItem value="INV003">1239</MenuItem>
                        <MenuItem value="INV004">33573</MenuItem>
                        <MenuItem value="INV005">33569</MenuItem>
                      </TextField>
                    </div>

                    {/* Store Wise Dropdown */}
                    <div style={{ width: "300px" }}>
                      <TextField
                        select
                        label="Store"
                        value={store}
                        onChange={(e) => setStore(e.target.value)}
                        size="small"
                        fullWidth
                      >
                        {/* <MenuItem value="">All</MenuItem> */}
                        <MenuItem value="STORE1">Pharmacy Store</MenuItem>
                        <MenuItem value="STORE2">I C U</MenuItem>
                        <MenuItem value="STORE3">General To Store</MenuItem>
                      </TextField>
                    </div>

                    {/* Supplier Dropdown */}
                    <div style={{ width: "300px" }}>
                      <TextField
                        select
                        label="Supplier"
                        value={supplier}
                        onChange={(e) => setSupplier(e.target.value)}
                        size="small"
                        fullWidth
                      >
                        {/* <MenuItem value="">All</MenuItem> */}
                        <MenuItem value="SUP1">SHAH MEDICO PVT LTD</MenuItem>
                        <MenuItem value="SUP2">ARI HELTH CARE</MenuItem>
                        <MenuItem value="SUP3">SHAH MEDICO PVT LTD</MenuItem>
                        <MenuItem value="SUP4">SHAH MEDICO PVT LTD</MenuItem>
                        <MenuItem value="SUP5">SHRIRAM DISTRIBUTORS</MenuItem>
                      </TextField>
                    </div>

                    <div style={{ width: "300px" }}>
                      <TextField
                        type="date"
                        label="From Date"
                        InputLabelProps={{ shrink: true }}
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </div>

                    <div style={{ width: "300px" }}>
                      <TextField
                        type="date"
                        label="To Date"
                        InputLabelProps={{ shrink: true }}
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        size="small"
                        fullWidth
                      />
                    </div>

                    <div className="flex items-center">
                      <CommonButton
                        searchIcon={true}
                        className="bg-blue-800 text-white"
                        type="button"
                        onClick={populateTable}
                        // disabled={!fromDate || !toDate}
                      />
                    </div>
                  </div>
                </div>

                <CommonBackDrop openBackdrop={openBackdrop} />
              </div>

              <hr className="w-full border-t-1 border-[#0B83A5] my-2" />

              {dataResult.length > 0 ? (
                <CommonDynamicTablePagination
                  dataResult={dataResult}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  count={count}
                  renderActions={RenderActions}
                  removeHeaders={["Id"]}
                  populateTable={populateTable}
                  actionsRequired={true}
                  highlightRow={false}
                />
              ) : (
                <h1 className="font-semibold text-gray-600 text-center pt-40">
                  Data Not Found
                </h1>
              )}
            </div>
          </div>

          <ConfirmationModal
            confirmationOpen={openChild}
            confirmationHandleClose={() => setOpenChild(false)}
            confirmationLabel="Confirmation"
            confirmationMsg="Are you sure want to delete this record ?"
            confirmationButtonMsg="Delete"
            // onConfirm={handleDelete}
          />
          <Dialog
            open={openGRNDialog}
            onClose={() => setOpenGRNDialog(false)}
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle sx={{ m: 0, p: 2, position: "relative" }}>
              View GRN Details
              <Box sx={{ position: "absolute", right: 8, top: 8 }}>
                <IconButton
                  onClick={() => setOpenGRNDialog(false)}
                  sx={{
                    backgroundColor: "red",
                    color: "white",
                    width: 32,
                    height: 20,
                    borderRadius: 1,
                    "&:hover": { backgroundColor: "#cc0000" },
                  }}
                >
                  <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
            </DialogTitle>

            <DialogContent dividers>
              <Box sx={{ overflowX: "auto" }}>
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200">
                      {Object.keys(
                        Array.isArray(getGRNDetails)
                          ? getGRNDetails[0] || {}
                          : getGRNDetails
                      ).map((key) => (
                        <th key={key} className="border px-3 py-2 text-left">
                          {key}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {(Array.isArray(getGRNDetails)
                      ? getGRNDetails
                      : [getGRNDetails]
                    ).map((row, index) => (
                      <tr key={index} className="border-b">
                        {Object.entries(row).map(([key, value]) => (
                          <td key={key} className="border px-3 py-2">
                            {key.toLowerCase().includes("date") && value
                              ? new Date(value).toLocaleDateString()
                              : String(value)}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </DialogContent>
          </Dialog>

          <Dialog
            open={openApproveDialog}
            onClose={() => setOpenApproveDialog(false)}
          >
            <DialogTitle>Confirmation</DialogTitle>
            <DialogContent>
              <p>Are you sure you want to approve this record?</p>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                onClick={() => setOpenApproveDialog(false)}
                color="error"
                variant="outlined"
              >
                Cancel
              </Button>

              <Button
                onClick={() => {
                  approveGRN(approveRowId)
                    .then((res) => {
                      console.log("GRN Approved:", res.data);

                      // ✅ disable Approve & Inward for this row
                      setApprovedRows((prev) => ({
                        ...prev,
                        [approveRowId]: true,
                      }));

                      setOpenApproveDialog(false);
                    })
                    .catch((err) => {
                      console.error("Approve error:", err);
                      alert("Failed to approve GRN");
                    });
                }}
                color="success"
                variant="contained"
              >
                Approve
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openInvertDialog}
            onClose={() => setOpenInvertDialog(false)}
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              GRN Inward Details
              <IconButton
                aria-label="close"
                onClick={() => setOpenInvertDialog(false)}
                size="small"
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  "&:hover": { backgroundColor: "#cc0000" },
                  width: 32,
                  height: 32,
                  borderRadius: "4px",
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              {invertGRNDetails ? (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{
                      maxWidth: "100%", // responsive width
                      overflowX: "auto",
                      borderRadius: 2,
                      boxShadow: 1,
                    }}
                  >
                    <Table
                      size="small"
                      sx={{
                        mb: 1,
                        borderCollapse: "collapse", // no double lines
                        "& td, & th": {
                          border: "none", // remove hr/borders
                          padding: "8px 12px",
                        },
                        "& tr:nth-of-type(even)": {
                          backgroundColor: "#f9f9f9", // subtle alternating bg
                        },
                        "& td:first-of-type, & td:nth-of-type(3)": {
                          fontWeight: "bold", // bold for label cells
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell>GRN Number</TableCell>
                          <TableCell>{invertGRNDetails.GRNNumber}</TableCell>
                          <TableCell>GRN Id</TableCell>
                          <TableCell>{invertGRNDetails.GRNId}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Date</TableCell>
                          <TableCell>{invertGRNDetails.Date}</TableCell>
                          <TableCell>Invoice No</TableCell>
                          <TableCell>{invertGRNDetails.InvoiceNo}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Invoice Date</TableCell>
                          <TableCell colSpan={3}>
                            {invertGRNDetails.InvoiceDate}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <b>Items:</b>
                  <TableContainer
                    component={Paper}
                    sx={{ maxHeight: 450, width: "100%" }}
                  >
                    <Table size="small" stickyHeader sx={{ minWidth: 700 }}>
                      <TableHead
                        sx={{
                          "& th": {
                            backgroundColor: "#DBDBDB",
                            color: "#242424",
                            fontWeight: "bold",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell
                            padding="checkbox"
                            sx={{
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              background: "#DBDBDB",
                            }}
                          >
                            {/* <Checkbox
                                                            indeterminate={selected.length > 0 && selected.length < itemsData.length}
                                                            checked={itemsData.length > 0 && selected.length === itemsData.length}
                                                            onChange={handleSelectAll}
                                                        /> */}
                            Select
                          </TableCell>

                          <TableCell
                            sx={{
                              whiteSpace: "nowrap",
                              fontWeight: "bold",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                            }}
                          >
                            Sr No
                          </TableCell>

                          <TableCell
                            sx={{
                              whiteSpace: "nowrap",
                              fontWeight: "bold",
                              position: "sticky",
                              left: 60,
                              zIndex: 3,
                              minWidth: 80,
                            }}
                          >
                            Item Id
                          </TableCell>

                          <TableCell
                            sx={{
                              whiteSpace: "nowrap",
                              minWidth: 220,
                              fontWeight: "bold",
                              position: "sticky",
                              left: 140,
                              zIndex: 3,
                            }}
                          >
                            Item Name
                          </TableCell>

                          <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                            Qty
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                            Batch No.
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                            Model No.
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 150 }}>
                            Serial No.
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                            Warranty Start Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                            Warranty End Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                            AMC Start Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                            AMC End Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                            Insurance Start Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", minWidth: 180 }}>
                            Insurance End Date
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {itemsData.length > 0 ? (
                          itemsData.map((desc, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                backgroundColor:
                                  index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                              }}
                            >
                              <TableCell
                                padding="checkbox"
                                sx={{
                                  position: "sticky",
                                  left: 0,
                                  backgroundColor:
                                    index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                                  zIndex: 2,
                                }}
                              >
                                <Checkbox
                                  checked={isSelected(desc.SrNo)}
                                  onChange={() => handleSelectRow(desc.SrNo)}
                                />
                              </TableCell>

                              <TableCell
                                sx={{
                                  position: "sticky",
                                  left: 0,
                                  backgroundColor:
                                    index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                                  zIndex: 2,
                                }}
                              >
                                {desc.SrNo}
                              </TableCell>
                              <TableCell
                                sx={{
                                  position: "sticky",
                                  left: 60,
                                  backgroundColor:
                                    index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                                  zIndex: 2,
                                }}
                              >
                                {desc.ItemId}
                              </TableCell>
                              <TableCell
                                sx={{
                                  position: "sticky",
                                  left: 140,
                                  backgroundColor:
                                    index % 2 === 0 ? "#f5f5f5" : "#ffffff",
                                  zIndex: 2,
                                  minWidth: 220,
                                }}
                              >
                                {desc.Description}
                              </TableCell>
                              <TableCell>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  type="number"
                                  value={desc.Quantity}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "Qty",
                                      e.target.value
                                    )
                                  }
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "4px 8px", // reduce vertical & horizontal padding
                                      fontSize: "0.8rem", // smaller text
                                    },
                                  }}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  value={desc.BatchNo}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "BatchNo",
                                      e.target.value
                                    )
                                  }
                                  disabled={!isSelected(desc.SrNo)}
                                  error={
                                    submitted &&
                                    isSelected(desc.SrNo) &&
                                    !desc.BatchNo?.trim()
                                  }
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "4px 8px",
                                      fontSize: "0.8rem",
                                    },
                                  }}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  value={desc.ModelNo}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "ModelNo",
                                      e.target.value
                                    )
                                  }
                                  disabled={!isSelected(desc.SrNo)}
                                  error={
                                    submitted &&
                                    isSelected(desc.SrNo) &&
                                    !desc.ModelNo?.trim()
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  value={desc.SerialNo}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "SerialNo",
                                      e.target.value
                                    )
                                  }
                                  disabled={!isSelected(desc.SrNo)}
                                  error={
                                    submitted &&
                                    isSelected(desc.SrNo) &&
                                    !desc.SerialNo?.trim()
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  type="date"
                                  variant="outlined"
                                  fullWidth
                                  value={formatDate(desc.warrantyStartDate)}
                                  onChange={(e) =>
                                    // e.target.value already comes back as "YYYY-MM-DD"
                                    // store it directly or convert to ISO string if needed
                                    handleInputChange(
                                      index,
                                      "warrantyStartDate",
                                      e.target.value
                                    )
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  type="date"
                                  variant="outlined"
                                  fullWidth
                                  value={formatDate(desc.warrantyEndDate)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "warrantyEndDate",
                                      e.target.value
                                    )
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  type="date"
                                  variant="outlined"
                                  fullWidth
                                  value={formatDate(desc.amcstartDate)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "amcstartDate",
                                      e.target.value
                                    )
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  type="date"
                                  variant="outlined"
                                  fullWidth
                                  value={formatDate(desc.amcendDate)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "amcendDate",
                                      e.target.value
                                    )
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  type="date"
                                  variant="outlined"
                                  fullWidth
                                  value={formatDate(desc.insuranceStartDate)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "insuranceStartDate",
                                      e.target.value
                                    )
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>

                              <TableCell>
                                <TextField
                                  size="small"
                                  type="date"
                                  variant="outlined"
                                  fullWidth
                                  value={formatDate(desc.insuranceEndDate)}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "insuranceEndDate",
                                      e.target.value
                                    )
                                  }
                                  sx={smallTextFieldSx}
                                />
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={7} align="center">
                              No descriptions found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <p>Loading data...</p>
              )}
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
              <Button
                variant="outlined"
                sx={{
                  borderColor: "red",
                  color: "red",
                  "&:hover": {
                    backgroundColor: "#ffebee", // light red on hover
                    borderColor: "red",
                  },
                }}
                onClick={() => setOpenInvertDialog(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#4caf50", // green
                  color: "white",
                  "&:hover": { backgroundColor: "#45a049" },
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </div>
  );
}
